import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { routes } from '../../index';
import Dashboard from './Dashboard';
import Renew from './Renew';
import MemberSearch from './MemberSearch';

const Membership = () => (
  <Switch>
    <Route exact path={routes.membership.root} component={Dashboard} />
    <Route exact path={routes.membership.renew} component={Renew} />
    <Route exact path={routes.membership.search} component={MemberSearch} />
  </Switch>
);

export default Membership;
